import Stack from "@mui/material/Stack";
import type { ReactNode } from "react";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

type Props = {
  children: ReactNode;
  align?: "start" | "center" | "end";
};

/** Right-aligned (by default) action button row at the bottom of forms. */
export default function AppActionsRow({ children, align = "end" }: Props) {
  const custom = useAppCustomStyles();
  return (
    <Stack
      direction="row"
      spacing={0.75}
      useFlexGap
      flexWrap="wrap"
      justifyContent={align === "start" ? "flex-start" : align === "center" ? "center" : "flex-end"}
      alignItems="center"
      sx={custom.components.layout.appActionsRow}
    >
      {children}
    </Stack>
  );
}
